/**
 * 服务端返回状态码
 */
enum ResponseCode {
  SUCCESS = 'success',
  ACCOUNT_ALREADY_EXISTS = 'AccountAlreadyExists',
}
export { ResponseCode };
